<template>
  <b-row>
    <b-col md="12" v-if="model.status === 4">
      <b-button variant="primary" @click="doApproveDraft()">Approve Draft</b-button>
    </b-col>
    <b-col md="12">
      <card class="stacked-form">
        <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
        <div class="row mb-5">
           <div class="col-md-6">
              <h4 class="mb-3"><strong>Data Order</strong></h4>
              <b-row>
                <b-col md="4">
                  <label for="">Kode</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.code}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Status</label>
                </b-col>
                <b-col md="8">
                  <span><b-badge :variant="getStatusColor(model.status)">{{getStatus(model.status)}}</b-badge><i class="fa fa-checked text-success" v-if="is_approve_draft"></i></span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Pembayaran dengan menggunakan Point?</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.is_use_point ? 'Ya' : 'Tidak'}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Berapa banyak point?</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.how_use}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Diskon</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.diskon}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Disablon</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.is_sablon === 0 ? 'Tidak' : 'Ya'}}</span>
                </b-col>
              </b-row>
              <template v-if="model.is_sablon !== 0">
                <b-row>
                  <b-col md="4">
                    <label for="">Jenis Sablon</label>
                  </b-col>
                  <b-col md="8">
                    <span>{{model.sablon.title}}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <label for="">Harga Sablon</label>
                  </b-col>
                  <b-col md="8">
                    <span>{{formatNumber(model.sablon_selling_price)}}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <label for="">Kuantitas Sablon</label>
                  </b-col>
                  <b-col md="8">
                    <span>{{model.sablon_quantity}}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <label for="">Harga Total Sablon</label>
                  </b-col>
                  <b-col md="8">
                    <span>{{formatNumber(model.sablon_total)}}</span>
                  </b-col>
                </b-row>
              </template>
              <template v-if="model.status === 0">
                <b-row>
                  <b-col md="4">
                    <label for="">Down Payment</label>
                  </b-col>
                  <b-col md="8">
                    <span>{{formatNumber(model.down_payment)}}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <label for="">Remaing Payment</label>
                  </b-col>
                  <b-col md="8">
                    <span>{{formatNumber(model.remaining_payment)}}</span>
                  </b-col>
                </b-row>
              </template>
              <b-row>
                <b-col md="4">
                  <label for="">Shipping</label>
                </b-col>
                <b-col md="8">
                  <span>{{formatNumber(model.shipping)}}</span>
                </b-col>
              </b-row>
           </div>
           <b-col md="6">
              <h4 class="mb-3"><strong>Data Pelanggan</strong></h4>
              <b-row>
                <b-col md="4">
                  <label for="">Nama</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.customer.name}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Kategori</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.customer.customer_category.name}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Alamat</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.customer.address !== null ? model.customer.address : '-'}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Email</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.customer.email !== null ? model.customer.email : '-'}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">No. Telp</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.customer.phone !== null ? model.customer.phone : '-'}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Terdaftar Tgl</label>
                </b-col>
                <b-col md="8">
                  <span>{{getDate(model.customer.registered_date)}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Dibuat Oleh</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.created_by.name}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="">Diperbaharui Oleh</label>
                </b-col>
                <b-col md="8">
                  <span>{{model.last_updated_by.name}}</span>
                </b-col>
              </b-row>
           </b-col>
        </div>
        <b-row>
          <b-col md="12">
            <b-row>
              <b-col md="6 mb-2">
                <h3 class="m-0"><strong>Detail Order</strong></h3>
              </b-col>
              <b-col md="6 text-right mb-2" v-if="model.status === 2 || model.status === 4">
                <b-button :variant="addProduct ? 'warning' : 'primary'" @click="addProduct = !addProduct"><font-awesome-icon v-if="addProduct" icon="times"/><font-awesome-icon v-else icon="plus"/> {{addProduct ? 'Batal' : 'Tambah Item'}} </b-button>
              </b-col>
            </b-row>
            <template v-if="addProduct && (model.status === 2 || model.status === 4)">
              <form v-on:submit.prevent="doSubmit">
                <b-row class="border ml-0 mr-0 mb-3 mt-3" v-for="(line, index) in lines" v-bind:key="index">
                  <template>
                    <b-col md="5">
                      <fg-input label="Produk">
                        <div class="form-group input-typeahead" v-bind:class="productError !== null ? 'has-error':''">
                          <typeahead ref="userProfileUuidTypeahead" customQueryParamName="name" :disabled="true" :labelFields="['product_name']" placeholder="Cari Product" :urlSearch="apiUrl.productSearch" arr-response="data" :model="line.product" :formType="'productSearch'" />
                          <p v-if="productError !== null" class="error" v-html="productError"></p>
                        </div>
                      </fg-input>
                    </b-col>
                    <!-- <b-col md="3">
                      <fg-input label="Harga">
                        <p class="pt-2"><strong>{{formatNumber(line.product.sellingPrice * line.quantity)}}</strong></p>
                      </fg-input>
                    </b-col> -->
                    <b-col md="3">
                      <fg-input v-if="model.customer.customer_category.name === 'Sepesial Member' && Object.keys(line.product).length > 0" label="Harga">
                        <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.smPrice) * line.quantity) : 0}}</strong></p>
                      </fg-input>
                      <fg-input v-else-if="model.customer.customer_category.name === 'Member' && Object.keys(line.product).length > 0" label="Harga">
                        <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.memberPrice) * line.quantity) : 0}}</strong></p>
                      </fg-input>
                      <fg-input v-else-if="model.customer.customer_category.name === 'Dropshipper' && Object.keys(line.product).length > 0" label="Harga">
                        <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.dropshipper) * line.quantity) : 0}}</strong></p>
                      </fg-input>
                      <fg-input v-else-if="model.customer.customer_category.name === 'Gold Member' && Object.keys(line.product).length > 0" label="Harga">
                        <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.gold_member) * line.quantity) : 0}}</strong></p>
                      </fg-input>
                      <fg-input v-else-if="(totalQty > 2 && totalQty <= 11) && (lines.length > 2 && lines.length <= 11) || (line.quantity > 2 && line.quantity <= 11) && (model.customer.customer_category.name !== 'Member' && this.model.customer.customer_category.name !== 'Dropshipper' || model.customer.customer_category.name !== 'Sepesial Member') && Object.keys(line.product).length > 0" label="Harga">
                        <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.more3) * line.quantity) : 0}}</strong></p>
                      </fg-input>
                      <fg-input v-else-if="(totalQty > 2 && totalQty <= 11) && (model.customer.customer_category.name !== 'Member' || this.model.customer.customer_category.name !== 'Dropshipper' || this.model.customer.customer_category.name !== 'Gold Member' || model.customer.customer_category.name !== 'Sepesial Member') && Object.keys(line.product).length > 0" label="Harga">
                        <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.more3) * line.quantity) : 0}}</strong></p>
                      </fg-input>
                      <fg-input v-else-if="totalQty > 11 && lines.length > 11 || line.quantity > 11 && (model.customer.customer_category.name !== 'Member'|| this.model.customer.customer_category.name !== 'Dropshipper' || this.model.customer.customer_category.name !== 'Gold Member' || model.customer.customer_category.name !== 'Sepesial Member') && Object.keys(line.product).length > 0" label="Harga">
                        <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.more12) * line.quantity) : 0}}</strong></p>
                      </fg-input>
                      <fg-input v-else-if="totalQty > 11 && (model.customer.customer_category.name !== 'Member' || this.model.customer.customer_category.name !== 'Dropshipper' || this.model.customer.customer_category.name !== 'Gold Member' || model.customer.customer_category.name !== 'Sepesial Member') && Object.keys(line.product).length > 0" label="Harga">
                        <p class="pt-2"><strong>{{line.product.sellingPrice > 0 ? formatNumber((line.product.more12) * line.quantity) : 0}}</strong></p>
                      </fg-input>
                      <fg-input v-else-if="Object.keys(line.product).length > 0" label="Harga">
                        <p class="pt-2"><strong>{{formatNumber(line.product.sellingPrice * line.quantity)}}</strong></p>
                      </fg-input>
                    </b-col>
                    <b-col md="2">
                      <fg-input label="Kuantitas" min="1" type="number" v-model="line.quantity"/>
                    </b-col>
                    <b-col md="1 mt-4-5 text-center">
                      <button type="button" @click="removeLine(index)" v-if="index >= 1 && $route.params.id === undefined" class="btn btn-danger"><i class="fa fa-times"></i></button>
                      <button type="button" @click="removeLine(index)" v-else class="btn btn-danger"><i class="fa fa-times"></i></button>
                    </b-col>
                    <b-col md="1 mt-4-5 text-center">
                      <b-button type="button" v-if="index + 1 === lines.length" @click="addLine" variant="primary" ><font-awesome-icon icon="plus"/></b-button>
                    </b-col>
                  </template>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <fg-input label="Diskon" type="number" v-model="formModel.diskon"/>
                  </b-col>
                  <b-col cols="6">
                    <fg-input label="PPN (%)" type="number" v-model="formModel.ppn"/>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <fg-input label="Mau disablon?">
                      <b-form-group>
                        <b-form-radio-group
                          id="isSablon"
                          v-model="formModel.is_sablon"
                          :options="optionsSablon"
                          name="radio-sablon"
                        ></b-form-radio-group>
                      </b-form-group>
                    </fg-input>
                  </b-col>
                </b-row>
                <b-row v-if="formModel.is_sablon === 1">
                  <b-col cols="4">
                    <fg-input label="Sablon">
                      <div class="form-group input-typeahead" v-bind:class="sablonError !== null ? 'has-error':''">
                        <typeahead ref="userProfileUuidTypeahead" customQueryParamName="title" :labelFields="['title']" placeholder="Cari Sablon" :urlSearch="apiUrl.sablon" arr-response="data" :model="formModel.sablon_id" />
                        <p v-if="sablonError !== null" class="error" v-html="sablonError"></p>
                      </div>
                    </fg-input>
                  </b-col>
                  <b-col cols="4">
                    <fg-input label="Harga Jual Sablon">
                      <p class="pt-2">{{formatNumber(model.sablon_quantity * model.sablon_selling_price)}}</p>
                    </fg-input>
                  </b-col>
                  <b-col cols="4">
                    <fg-input label="Kuantitas" type="number" v-model="formModel.sablon_quantity"/>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="warning" @click="addProduct = !addLine"><font-awesome-icon icon="times"/> Batal</b-button>
                  </b-col>
                  <b-col cols="6">
                    <b-button variant="primary" class="float-right" type="submit"><font-awesome-icon icon="save"/> Submit</b-button>
                  </b-col>
                </b-row>
              </form>
            </template>
            <div class="table-responsive mt-3">
              <table class="table table-hoverd table-striped">
                <tr>
                  <th>Item</th>
                  <th class="text-right">Harga</th>
                  <th class="text-right">Kuantitas</th>
                  <th class="text-right">Total</th>
                  <th class="text-right" v-if="model.status === 2 || model.status === 4"></th>
                </tr>
                <tbody v-if="model.order_detail.length > 0">
                  <tr v-for="(orderDetail, index) in model.order_detail" :key="orderDetail.id">
                    <td>
                      {{orderDetail.product_size.product_color.product_categories.product.name}} - 
                      {{orderDetail.product_size.product_color.product_categories.category.name}} - 
                      {{orderDetail.product_size.product_color.color.name}} - 
                      {{orderDetail.product_size.size.name}}
                    </td>
                    <td class="text-right">{{formatNumber(orderDetail.selling_price)}}</td>
                    <td class="text-right">
                      <template v-if="model.orderDetailId === orderDetail.id">
                        <fg-input placeholder="Masukkan quantity" min="1" type="number" v-model="orderDetail.quantity"/>
                      </template>
                      <template v-else>
                        {{orderDetail.quantity}}
                      </template>
                    </td>
                    <td class="text-right">{{formatNumber(orderDetail.sub_total)}}</td>
                    <td class="text-right" v-if="model.status === 2 || model.status === 4">
                      <template v-if="model.orderDetailId === orderDetail.id">
                        <b-button variant="danger" @click="doReset(index)"><font-awesome-icon icon="times"/></b-button>
                        <b-button variant="success" @click="doEditOrderDetail(orderDetail)"><font-awesome-icon icon="check"/></b-button>
                      </template>
                      <template v-else>
                        <b-button variant="success" @click="openEditOrderDetail(orderDetail)"><font-awesome-icon icon="pencil-alt"/></b-button>
                        <b-button variant="danger" @click="doDeleteOrderDetail(orderDetail.id)"><font-awesome-icon icon="trash"/></b-button>
                      </template>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="7" class="text-center">Tidak list item untuk saat ini</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <h3 class="mb-5"><strong>Riwayat Order</strong></h3>
            <table class="table table-hoverd table-striped">
              <tr>
                <th>Dibuat Oleh</th>
                <th>Diperbaharui Oleh</th>
                <th>Status</th>
                <th>Tgl. Terbit</th>
              </tr>
              <tr v-for="orderLog in orderLogList" :key="orderLog.id">
                <td>{{orderLog.created_by.name}}</td>
                <td>{{orderLog.last_updated_by.name}}</td>
                <td><b-badge :variant="getStatusColor(orderLog.status)">{{getStatus(orderLog.status)}}</b-badge></td>
                <td>{{orderLog.created_at}}</td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <back-button/>
      </card>
    </b-col>
    <div class="bubble-info">
      <b-button @click="doExportStruct()" variant="secondary" download><font-awesome-icon icon="print"/> Cetak Struk</b-button>
      <b-button @click="doExportInvoice()" variant="secondary" download><font-awesome-icon icon="print"/> Cetak Invoice</b-button>
        <b-button variant="danger" @click="doCancleOrder()" v-if="parseInt(model.status) !== 1 && parseInt(model.status) !== 3"><font-awesome-icon icon="times"/> Batalkan Order</b-button>
        <b-button variant="success" @click="doApproveOrder()" v-if="parseInt(model.status) !== 1 && parseInt(model.status) !== 3"><font-awesome-icon icon="check"/> Setujui Order</b-button>
      <div class="btn btn-info"><strong>Total : {{formatNumber(model.total + totalSummary)}}</strong></div>
    </div>
  </b-row>
</template>

<script>
  import {Autocomplete, Switch} from 'element-ui'
  import {Progress as LProgress} from 'src/components/index'
  import SaveData from '@/components/Buttons/SaveData'
  import Back from '@/components/Buttons/Back'
  import Typeahead from '@/components/Typeahead'

  export default {
    components: {
      LProgress,
      SaveDataButton: SaveData,
      BackButton: Back,
      LSwitch: Switch,
      [Autocomplete.name]: Autocomplete,
      Typeahead
    },
    data () {
      return {
        bgColor: '#778899',
        position: 'bottom-right',
        isLoading: false,
        apiUrl: {
          order: window.AppConfig.apiUrl + 'order',
          orderDetail: window.AppConfig.apiUrl + 'order-detail',
          orderLog: window.AppConfig.apiUrl + 'order-log',
          productSearch: window.AppConfig.apiUrl + 'product-search'
        },
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        optionsPaymentType: [
          { text: 'Cash', value: 0 },
          { text: 'Tahan pembayaran', value: 1 },
          { text: 'Bayar di muka', value: 2 }
        ],
        optionsSablon: [
          { text: 'Ya', value: 1 },
          { text: 'Tidak', value: 0 }
        ],
        lines: [{
          product: {
            value: null,
            sellingPrice: 0,
            capitalPrice: 0,
            smPrice: 0,
            memberPrice: 0,
            more3: 0,
            more12: 0
          },
          quantity: 1
        }],
        formModel: {
          diskon: 0,
          ppn: 0,
          customer: {
            customer_category: {}
          },
          sablon_id: {
            value: null,
            label: null
          }
        },
        blockRemoval: true,
        addProductRequest: {
          product: {
            value: null,
            sellingPrice: 0,
            capitalPrice: 0
          }
        },
        productError: null,
        addProduct: false,
        orderLogList: [],
        sablonError: null,
        fakeModel: {
          orderDetailQuantity: null
        },
        fakeTotalQty: null,
        totalQty: null,
        model: {
          is_use_point: false,
          how_use: 0,
          is_approve_draft: false,
          orderDetailId: null,
          code: null,
          created_at: null,
          created_by: {},
          last_updated_by: {},
          customer: {
            customer_category: {}
          },
          diskon: null,
          down_payment: null,
          is_sablon: null,
          order_detail: [],
          payment_type: null,
          ppn: null,
          profit: null,
          remaining_payment: null,
          sablon_capital_price: null,
          sablon_id: {
            value: null,
            label: null
          },
          sablon: {
            capital_price: null
          },
          sablon_quantity: null,
          sablon_selling_price: null,
          sablon_total: null,
          status: null,
          shipping: 0,
          total: null
        }
      }
    },
    watch: {
      lines () {
        this.blockRemoval = this.lines.length <= 1
      },
      '$route.params.uuid': function (val) {
        this.getDetail()
      },
      addProduct () {
        this.lines = [{
          product: {
            value: null,
            sellingPrice: 0,
            capitalPrice: 0,
            smPrice: 0,
            memberPrice: 0,
            more3: 0,
            more12: 0
          },
          quantity: 1
        }]
      }
    },
    mounted () {
      console.log('test')
      this.getDetail()
      this.getOrderLog()
    },
    computed: {
      totalSummary: function () {
        let total = 0
        let subTotal = 0
        this.totalQty = this.fakeTotalQty
        if (this.lines[0].product.value !== null) {
          // this.lines.forEach(data => {
          // this.totalQty += parseInt(data.quantity)
          // })
          this.lines.forEach(data => {
            this.totalQty += parseInt(data.quantity)
            if (this.model.customer.customer_category.name === 'Member' && data.product.sellingPrice > 0) {
              subTotal = data.product.memberPrice * parseInt(data.quantity)
              total += subTotal
            } else if (this.model.customer.customer_category.name === 'Sepesial Member' && data.product.sellingPrice > 0) {
              subTotal = data.product.smPrice * parseInt(data.quantity)
              total += subTotal
            } else if (this.model.customer.customer_category.name === 'Dropshipper' && data.product.sellingPrice > 0) {
              subTotal = data.product.dropshipper * parseInt(data.quantity)
              total += subTotal
            } else if (this.model.customer.customer_category.name === 'Gold Member' && data.product.sellingPrice > 0) {
              subTotal = data.product.gold_member * parseInt(data.quantity)
              total += subTotal
            } else if ((this.totalQty > 2 && this.totalQty <= 11) || (this.lines.length > 2 && this.lines.length <= 11) || (parseInt(data.quantity) > 2 && parseInt(data.quantity) <= 11) && (this.model.customer.customer_category.name !== 'Member' && this.model.customer.customer_category.name !== 'Dropshipper' && this.model.customer.customer_category.name !== 'Gold Member' && this.model.customer.customer_category.name !== 'Sepesial Member')) {
              subTotal = data.product.more3 * parseInt(data.quantity)
              total += subTotal
            } else if (this.totalQty > 11 && this.lines.length > 11 || parseInt(data.quantity) > 11 && (this.model.customer.customer_category.name !== 'Member' && this.model.customer.customer_category.name !== 'Dropshipper' && this.model.customer.customer_category.name !== 'Gold Member' && this.model.customer.customer_category.name !== 'Sepesial Member')) {
              subTotal = data.product.more12 * parseInt(data.quantity)
              total += subTotal
            } else if ((this.totalQty > 2 && this.totalQty <= 11) && (this.model.customer.customer_category.name !== 'Member' && this.model.customer.customer_category.name !== 'Dropshipper' && this.model.customer.customer_category.name !== 'Gold Member' && this.model.customer.customer_category.name !== 'Sepesial Member')) {
              subTotal = data.product.more3 * parseInt(data.quantity)
              total += subTotal
            } else if (this.totalQty > 11 && (this.model.customer.customer_category.name !== 'Member' && this.model.customer.customer_category.name !== 'Dropshipper' && this.model.customer.customer_category.name !== 'Gold Member' && this.model.customer.customer_category.name !== 'Sepesial Member')) {
              subTotal = data.product.more12 * parseInt(data.quantity)
              total += subTotal
            } else {
              subTotal = data.product.sellingPrice * parseInt(data.quantity)
              total += subTotal
            }
          })
          if (this.model.is_sablon === 1) {
            total = total + (this.model.sablon_selling_price * this.model.sablon_quantity)
          }
          if (this.model.diskon > 0) {
            total = total - this.model.diskon
          }
          if (this.model.ppn > 0) {
            let afterPpn = (total * this.model.ppn) / 100
            total = total + afterPpn
          }
        }
        return total + parseInt(this.model.shipping)
      }
    },
    methods: {
      addLine () {
        this.lines.push({
          product: {
            value: null,
            sellingPrice: 0,
            capitalPrice: 0,
            smPrice: 0,
            memberPrice: 0,
            more3: 0,
            more12: 0
          },
          quantity: 1
        })
      },
      removeLine (lineId) {
        if (!this.blockRemoval) this.lines.splice(lineId, 1)
      },
      doApproveDraft () {
        this.$http.patch(this.apiUrl.approveDraft + '/' + this.$route.params.id + '/approve-draft', {
          is_approve_draft: true
        })
        .then(() => {
          this.getDetail()
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      getDetail () {
        this.isLoading = true
        this.$http.get(this.apiUrl.order + '/' + this.$route.params.id)
        .then(response => {
          this.model.code = response.data.code
          this.model.is_use_point = response.data.is_use_point
          this.model.how_use = response.data.how_use
          this.model.created_at = response.data.created_at
          this.model.created_by = response.data.created_by
          this.model.last_updated_by = response.data.last_updated_by
          this.model.customer = response.data.customer
          this.model.diskon = response.data.diskon
          this.model.down_payment = response.data.down_payment
          this.model.is_approve_draft = response.data.is_approve_draft
          this.model.is_sablon = response.data.is_sablon
          this.model.order_detail = []
          this.fakeTotalQty = 0
          this.totalQty = 0
          response.data.order_detail.forEach(data => {
            this.totalQty += parseInt(data.quantity)
            this.fakeTotalQty += parseInt(data.quantity)
            this.model.order_detail.push(data)
          })
          this.model.payment_type = response.data.payment_type
          this.model.ppn = response.data.ppn
          this.model.profit = response.data.profit
          this.model.remaining_payment = response.data.remaining_payment
          this.model.sablon_capital_price = response.data.sablon_capital_price
          this.model.sablon_id.value = response.data.sablon !== null ? response.data.sablon.id : null
          this.model.sablon_id.label = response.data.sablon !== null ? response.data.sablon.title : null
          this.model.sablon_quantity = response.data.sablon_quantity
          this.model.sablon_selling_price = response.data.sablon_selling_price
          this.model.sablon = response.data.sablon
          this.model.sablon_total = response.data.sablon_total
          this.model.status = response.data.status
          this.model.total = response.data.total
          this.model.shipping = response.data.shipping
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      getOrderLog () {
        this.$http.get(this.apiUrl.orderLog + '?order_id=' + this.$route.params.id).then(resp => {
          this.orderLogList = []
          resp.data.data.forEach(data => {
            this.orderLogList.push(data)
          })
        })
      },
      getStatus (value) {
        switch (value) {
          case 0:
            return 'Pending'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'Lunas'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'Tahan'
            // eslint-disable-next-line no-unreachable
            break
          case 3:
            return 'Batal'
            // eslint-disable-next-line no-unreachable
            break
          case 4:
            return 'Draft'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusColor (value) {
        switch (value) {
          case 0:
            return 'warning'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'secondary'
            // eslint-disable-next-line no-unreachable
            break
          case 3:
            return 'danger'
            // eslint-disable-next-line no-unreachable
            break
          case 4:
            return 'info'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      formatNumber (num) {
        if (num !== null) {
          return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
        }
      },
      openEditOrderDetail (value) {
        this.model.orderDetailId = value.id
        this.fakeModel.orderDetailQuantity = value.quantity
      },
      doEditOrderDetail (value) {
        this.$swal({
          title: 'Apakah anda sudah yakin?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, Sudah',
          cancelButtonText: 'Tidak, belum',
          confirmButtonClass: 'btn btn-success mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$validator.validateAll().then(res => {
              if (res) {
                let model = {
                  quantity: value.quantity,
                  sellingPrice: value.selling_price,
                  capitalPrice: value.capital_price,
                  product_size_id: value.product_size_id,
                  orderId: this.$route.params.id,
                  customerCategory: this.model.customer.customer_category.name
                }
                this.saveButtonData.isLoading = true
                this.$http.patch(this.apiUrl.orderDetail + '/' + value.id, model).then(response => {
                  this.getDetail()
                  this.saveButtonData.isLoading = false
                  this.model.orderDetailId = null
                  this.$store.dispatch('notification/success', 'Item berhasil diubah.')
                }).catch(error => {
                  this.saveButtonData.isLoading = false
                  this.$store.dispatch('notification/error', error)
                })
              }
            })
          }
        })
      },
      doReset (index) {
        this.model.order_detail[index].quantity = this.fakeModel.orderDetailQuantity
        this.model.orderDetailId = null
      },
      doExportStruct () {
        window.open(window.AppConfig.webUrl + 'ipdf/po/' + this.$route.params.id)
      },
      doExportInvoice () {
        window.open(window.AppConfig.webUrl + 'invoice/' + this.$route.params.id)
        // 'https://posbackend.jaketdistromedan.com/invoice/' + this.$route.params.id
      },
      doDeleteOrderDetail (id) {
        this.$swal({
          title: 'Apakah anda yakin?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, saya yakin',
          cancelButtonText: 'Tidak, saya tidak yakin',
          confirmButtonClass: 'btn btn-danger mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$http.delete(this.apiUrl.orderDetail + '/' + id)
            .then(response => {
              this.getDetail()
              this.$store.dispatch('notification/success', 'Item berhasil dihapus')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      doSubmit () {
        this.$swal({
          title: 'Apakah anda sudah yakin?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, Sudah',
          cancelButtonText: 'Tidak, belum',
          confirmButtonClass: 'btn btn-success mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$validator.validateAll().then(res => {
              if (res) {
                let model = {}
                this.saveButtonData.isLoading = true
                model.product = []
                this.lines.forEach(data => {
                  if (data.product.value !== null) {
                    model.product.push({
                      productName: data.product.label,
                      productSize: data.product.value,
                      capitalPrice: data.product.capitalPrice,
                      sellingPrice: data.product.sellingPrice,
                      memberPrice: data.product.memberPrice,
                      smPrice: data.product.smPrice,
                      more3: data.product.more3,
                      more12: data.product.more12,
                      quantity: parseInt(data.quantity)
                    })
                  }
                })
                model.customer = this.model.customer.customer_category.name
                model.order = this.$route.params.id
                model.diskon = this.formModel.diskon
                model.ppn = this.formModel.ppn
                model.isSablon = this.formModel.is_sablon
                if (this.formModel.is_sablon === 1) {
                  model.sablonId = this.formModel.sablon_id.value
                  model.sablonSellingPrice = this.formModel.sablon_selling_price
                  model.sablonQuantity = this.formModel.sablon_quantity
                }
                this.$http.post(this.apiUrl.orderDetail, model).then(response => {
                  this.getDetail()
                  this.saveButtonData.isLoading = false
                  this.addProduct = false
                  this.$store.dispatch('notification/success', 'Item produk berhasil ditambahkan.')
                }).catch(error => {
                  this.saveButtonData.isLoading = false
                  this.$store.dispatch('notification/error', error)
                })
              }
            })
          }
        })
      },
      doCancleOrder () {
        this.$swal({
          title: 'Apakah anda yakin?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, saya yakin',
          cancelButtonText: 'Tidak, saya tidak yakin',
          confirmButtonClass: 'btn btn-danger mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            let products = []
            this.model.order_detail.forEach(data => {
              products.push({
                productSize: data.product_size.id,
                quantity: parseInt(data.quantity)
              })
            })
            this.$http.patch(window.AppConfig.apiUrl + 'order-cancle' + '/' + this.$route.params.id, {
              products
            })
            .then(response => {
              this.getDetail()
              this.getOrderLog()
              this.$store.dispatch('notification/success', 'Order berhasil dibatalkan')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      doApproveOrder () {
        this.$swal({
          title: 'Apakah anda yakin?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, saya yakin',
          cancelButtonText: 'Tidak, saya tidak yakin',
          confirmButtonClass: 'btn btn-success mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$http.patch(window.AppConfig.apiUrl + 'order-approve' + '/' + this.$route.params.id)
            .then(response => {
              this.getDetail()
              this.getOrderLog()
              this.addProduct = false
              this.$store.dispatch('notification/success', 'Order berhasil disetujui')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      getDate (value) {
        return this.$moment(value).format('DD-MM-YYYY')
      }
    }
  }
</script>

<style scooped>
  .fixed-top-selling {
    position: fixed;
    float: right !important;
    /* top: 0; */
    right: 0;
    /* left: 0; */
    width: 27%;
  }
  .fixed-top-downpayment {
    position: fixed;
    float: right !important;
    top: 48%;
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
  .mt-4-5 {
    margin-top: 1.7rem !important;
  }
  .bubble-info {
    position: fixed;
    right: 0;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Orders/Show.vue